import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const API = `${API_BASE_URL}/api`;

/**
 * useExerciseLock — polls /lock-status for an exercise and returns
 * { locked, lockedAt, lockedByName, loading, refresh }.
 *
 * Auto-refreshes every 20s so if another user locks/unlocks from a
 * different device, the UI catches up without a page reload.
 */
export default function useExerciseLock(exerciseId) {
  const [state, setState] = useState({
    locked: false,
    lockedAt: null,
    lockedByName: null,
    loading: false,
  });

  const refresh = useCallback(async () => {
    if (!exerciseId) return;
    setState((s) => ({ ...s, loading: true }));
    try {
      const res = await axios.get(`${API}/exercise-builder/${exerciseId}/lock-status`);
      setState({
        locked: Boolean(res.data?.locked),
        lockedAt: res.data?.locked_at || null,
        lockedByName: res.data?.locked_by_name || null,
        loading: false,
      });
    } catch {
      setState((s) => ({ ...s, loading: false }));
    }
  }, [exerciseId]);

  useEffect(() => {
    refresh();
    if (!exerciseId) return undefined;
    const t = setInterval(refresh, 20000);
    return () => clearInterval(t);
  }, [refresh, exerciseId]);

  return { ...state, refresh };
}
